"use client";

import { createContext, useContext, type ReactNode } from "react";
import { useTheme } from "@/hooks/useTheme";
import type { ThemeColorKey, FontFamilyKey } from "@/lib/constants";

interface ThemeContextValue {
  themeColor: ThemeColorKey;
  fontFamily: FontFamilyKey;
  accentColor: string;
  fontFamilyValue: string;
  setThemeColor: (color: ThemeColorKey) => void;
  setFontFamily: (font: FontFamilyKey) => void;
}

const ThemeContext = createContext<ThemeContextValue | null>(null);

export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useTheme();
  return (
    <ThemeContext.Provider value={theme}>
      <div
        style={{
          fontFamily: theme.fontFamilyValue,
          ["--accent-color" as string]: theme.accentColor,
        }}
      >
        {children}
      </div>
    </ThemeContext.Provider>
  );
}

export function useThemeContext() {
  const context = useContext(ThemeContext);
  if (!context) throw new Error("useThemeContext must be used within ThemeProvider");
  return context;
}
